<script setup lang="ts">
const { messages, typing = false } = defineProps<{
  messages: Message[];
  typing?: boolean;
}>();

const { assistantSettings } = useAssistantSettingsStore();

const scrollable = ref<HTMLDivElement | null>(null);

const isReportMessageOpen = ref(false);
const reportMessage = ref<Message | undefined>(undefined);

const onDislike = (message: Message) => {
  if (!message.id) return;
  // Open report message modal
  reportMessage.value = message;
  window.setTimeout(() => {
    isReportMessageOpen.value = true;
  }, 100);
};

onMounted(() => {
  useScrollOnChatUpdate(scrollable.value);
});
</script>

<template>
  <div ref="scrollable" class="chat-messages">
    <div class="inner">
      <PoweredBy
        v-if="assistantSettings.config.has_branding"
        class="powered-by"
        size="small"
      ></PoweredBy>
      <!-- <TransitionScale :duration="400" :scale="0"> -->
      <ChatMessageTyping v-show="typing" />
      <!-- </TransitionScale> -->
      <ChatMessage
        v-for="message in messages.slice().reverse()"
        :id="message.id"
        :key="message.id"
        class="message"
        :content="message.content"
        :time="message.time"
        :role="message.role"
        :rich-data="message.rich_data"
        :rating="!!message.id && message.role === 'assistant'"
        @dislike="() => onDislike(message)"
      />

      <ChatIntro class="intro" />

      <ModalReportMessage
        v-model="isReportMessageOpen"
        :message="reportMessage"
      ></ModalReportMessage>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chat-messages {
  display: flex;
  flex-direction: column-reverse;
  background-color: var(--chat-body-background-color);
  color: var(--chat-body-text-color);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.inner {
  display: flex;
  flex-grow: 1;
  flex-direction: column-reverse;
  gap: 1rem;
  padding: 10px;
}

.message {
  max-width: 90%;
}

.powered-by {
  align-self: center;
  margin-bottom: 10px;
}

.intro {
  flex-grow: 1;
}
</style>
